import { render, staticRenderFns } from "./CalendarChat.vue?vue&type=template&id=16dd9336&scoped=true&"
import script from "./CalendarChat.vue?vue&type=script&lang=js&"
export * from "./CalendarChat.vue?vue&type=script&lang=js&"
import style0 from "./CalendarChat.vue?vue&type=style&index=0&id=16dd9336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dd9336",
  null
  
)

export default component.exports